import $ from 'jquery';

$(function() {
    $('.back-button__link').on('click', function(e) {
        e.preventDefault();
        history.go(-1);
    })
})